


(function (){
    let infScrollOptions = {
        path: '.pagination a.next',
        append: '.product-list .product-block',
        history: false,
        hideNav: '.pagination',
        status: '.page-load-status',
        scrollThreshold: 100
    };
    let infScrollContainer = '.collection-listing .product-list';

    function initInfScroll(toDestroy) {
        if (toDestroy)
            toDestroy.destroy();

        if (!jQuery('.pagination a.next').length)
            return;

        let infScroll = new InfiniteScroll(infScrollContainer, infScrollOptions);
        infScroll.on('append', () => {
            window.SwymCallbacks.push((swat) =>
                swat.initializeActionButtons(".collection-listing")
            );
            theme.ProductBlockManager.loadImages();
        })

        return infScroll;
    }

    let infScrollInstance = initInfScroll();
    jQuery(document).on("cc:ajax-collection:loaded", () => initInfScroll(infScrollInstance));

})();
